import {initWebComponent} from "@/helpers/web-component-helper";
import {zoomToLayer} from "@/helpers/ol/ol-zoom-helper";
import {getBranchItemByBookmarkPresentationID} from "@/helpers/tree-helper.js";


export class LayerMenuActiveItemZoomComponent extends HTMLElement{
    constructor(){
        super();
        const template = document.createElement('template');
        let label = this.closest('layer-menu-group-item')
        if(label) {
            label = label.dataset.label
        } else if(this.getAttribute('data-label')) {
            label = this.getAttribute('data-label')
        } else {
            label = ''
        }

        template.innerHTML = `<button title="Inzoomen naar: ${label}" class="btn btn-sm btn-outline-secondary icon-btn text-transform-none mr-1" href="#">
          <span class="fa fa-expand"></span>
        </button>`

        initWebComponent(this, template)

        const id = this.getAttribute('data-id')

        this.addEventListener('click', () => {
            zoomToLayer(id)
        });
    }
}
